'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'inbox';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f01c';
var svgPathData = 'M32 448l448 0 0-112-103.4 0-27.3 40.9-4.7 7.1-177.1 0-4.8-7.1-27.2-40.9-103.4 0 0 112zM478 304l-26.7-240-390.7 0-26.7 240 118.6 0 4.8 7.1 27.2 40.9 142.9 0 27.3-40.9 4.7-7.1 118.6 0zM0 320l32-288 448 0 32 288 0 160-512 0 0-160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faInbox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;